import { render } from "./LzIcon.vue?vue&type=template&id=0ca0cb7e"
import script from "./LzIcon.vue?vue&type=script&lang=js"
export * from "./LzIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__